import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AppLayout, type RouteHandle } from '../layout/AppLayout';
import { RequireAuth } from '@/features/auth/components/RequireAuth';
import { ErrorState } from '@/design-system/ui/States';

/** Route-level code splitting: each page ships as its own chunk. */
const page = (load: () => Promise<{ default: React.ComponentType }>) => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const focused: RouteHandle = { hideTabBar: true };

export const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    errorElement: <ErrorState title="خطای غیرمنتظره" message="مشکلی در نمایش صفحه پیش آمد. صفحه را دوباره بارگذاری کنید." onRetry={() => window.location.reload()} />,
    children: [
      { index: true, ...page(() => import('@/features/trips/pages/HomePage')) },
      { path: 'trips', ...page(() => import('@/features/trips/pages/TripListPage')) },
      { path: 'trip/normal/:travelId', handle: focused, ...page(() => import('@/features/booking/pages/NormalBookingPage')) },
      // { path: 'trip/exclusive/:travelId', handle: focused, ...page(() => import('@/features/booking/pages/ExclusiveBookingPage')) },
      { path: 'payment', handle: focused, ...page(() => import('@/features/payment/pages/PaymentResultPage')) },
      { path: 'track', ...page(() => import('@/features/loads/pages/TrackLoadPage')) },
      { path: 'why-blino', ...page(() => import('@/features/content/pages/WhyBlinoPage')) },
      { path: 'magazine', ...page(() => import('@/features/content/pages/MagazinePage')) },
      { path: 'magazine/:slug', ...page(() => import('@/features/content/pages/MagazineArticlePage')) },
      { path: 'faq', ...page(() => import('@/features/content/pages/FaqPage')) },
      { path: 'terms', ...page(() => import('@/features/content/pages/TermsPage')) },
      { path: 'contact', ...page(() => import('@/features/content/pages/ContactPage')) },
      { path: 'complaint', ...page(() => import('@/features/content/pages/ComplaintPage')) },
      { path: 'careers', ...page(() => import('@/features/content/pages/CareersPage')) },
      // Not linked from the menus yet (same as on the old site) — the route is ready for when it is.
      { path: 'agencies', ...page(() => import('@/features/content/pages/AgenciesPage')) },
      { path: 'door-to-door', ...page(() => import('@/features/door-to-door/pages/DoorToDoorPage')) },
      { path: 'profile', ...page(() => import('@/features/profile/pages/ProfilePage')) },
      {
        element: <RequireAuth />,
        children: [
          { path: 'tickets', ...page(() => import('@/features/tickets/pages/TicketsPage')) },
          { path: 'tickets/:kind/:ticketId', ...page(() => import('@/features/tickets/pages/TicketDetailPage')) },
          { path: 'wallet', ...page(() => import('@/features/wallet/pages/WalletPage')) },
          { path: 'loads', ...page(() => import('@/features/loads/pages/LoadsPage')) },
        ],
      },
      { path: '*', ...page(() => import('./NotFoundPage')) },
    ],
  },
];

export const router = createBrowserRouter(routes);
